import { contactInfo } from "@/mocks/homeData";

export default function MobileBottomBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200 shadow-[0_-4px_12px_rgba(0,0,0,0.05)] px-4 py-3">
      <div className="flex items-center gap-3">
        <a
          href={contactInfo.phoneHref}
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-md transition-colors whitespace-nowrap"
        >
          <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
          Appeler
        </a>
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${contactInfo.mapsQuery}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-secondary-500 hover:bg-secondary-600 text-white font-semibold text-sm rounded-md transition-colors whitespace-nowrap"
        >
          <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
          Itinéraire
        </a>
      </div>
    </div>
  );
}